import * as React from 'react'
import styled from 'styled-components'
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'

interface StyledTooltipProps extends TooltipProps {
  customPadding?: string
  minWidth?: string
}

const StyledTooltip = styled(({ className, title, customPadding, minWidth, ...props }: StyledTooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} title={title || ''} />
))(({ theme, customPadding, minWidth }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.colors.backgroundContrast,
    color: theme.colors.text,
    boxShadow: '0px 16px 32px 0px #00000040',
    fontSize: 14,
    fontFamily: 'SpaceGroteskRegular',
    lineHeight: '24px',
    padding: customPadding || '4px 8px',
    borderRadius: 8,
    width: '100%',
    minWidth: minWidth || 'auto'
  }
}))

export default StyledTooltip
